<app-team-header size="small" [team]="requestTeam" [showBackButton]="false" [showEditIcon]="false"></app-team-header>
<div *ngFor="let member of memberSort(requestTeam)" class="margin-left-2">
    <h4 class="font-size-small margin-top-half">{{ memberName(member) }}</h4>
    <app-action-buttons>
        <button type="button" class="button button--small button--primary" *ngFor="let action of member.ownerActions" (click)="dispatch(action)">
            {{ action.text | translate }}
        </button>
    </app-action-buttons>
</div>
